/**
 * Regra do vínculo "pessoa x função" no ministério (migration 0112).
 *
 * O líder dá a função DIRETO (sem convite) a quem já é integrante ativo. A exceção são as
 * funções que dão poder: Líder do Ministério (`eh_lider`) e Gestor de elo
 * (`pode_gerenciar_modulo`). Essas continuam por convite e dependem do aceite da própria
 * pessoa. O banco impõe a mesma regra (trigger trg_pessoa_ministerio_exige_aceite); aqui só
 * decidimos qual status a tela grava e o que ela mostra.
 */
export function funcaoExigeAceite(funcao: {
  eh_lider: boolean;
  pode_gerenciar_modulo: boolean;
}): boolean {
  return funcao.eh_lider || funcao.pode_gerenciar_modulo;
}
